import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        treeData: {
            id: 20,
            name: "全国",
            code: 20,
        },
        examData: [],
        advisoryList: [], //资讯
        moduleData: {}, //资讯模块 信息 moduleId moduleCode

        bikaoIdandcode: {}, //必考指南 moduleId moduleCode

    },
    getters: {

    },
    mutations: {
        treeData(state, payload) {

            state.treeData = payload;

        },
        examDatas(state, payload) {

            state.examData = payload;

        },
        //资讯
        advisoryfn(state, payload) {
            state.advisoryList = payload;

        },
        //招聘信息ID 
        moduleIdfn(state, payload) {
            state.moduleData = payload;
        },
        //招聘信息ID  code
        bikaoIds(state, payload) {
            state.bikaoIdandcode = payload;

        },



    },
    actions: {},
    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js